import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconStage"><Path fillRule="evenodd" clipRule="evenodd" d="M2 6.75C2 5.23122 3.23122 4 4.75 4H19.25C20.7688 4 22 5.23122 22 6.75V17.25C22 18.7688 20.7688 20 19.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75ZM20.1028 18.164L17.8009 15.8655C17.5666 15.6314 17.2489 15.5 16.9177 15.5H7.07843C6.74691 15.5 6.42896 15.6317 6.19454 15.8661L3.89696 18.1637C4.12033 18.3723 4.42025 18.5 4.75 18.5H19.25C19.5796 18.5 19.8794 18.3724 20.1028 18.164Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStage;
